exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget--border-box .widget__title[data-v-13059b29]{height:auto;padding-left:0;border:none;border-left:none}.widget--border-box.single-cat .posts-wrap[data-v-13059b29]{padding:0;border-right:none;border-bottom:none;border-left:none}.widget--border-box .widget__title h4[data-v-13059b29]{margin:0;line-height:23px;margin-bottom:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13059b29","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 114
// module chunks = 0